import { MarketingChannel, MarketingContext } from '@/models';
import { CustomerError } from '@/services/customer/customer.service';
import Vue from 'vue';
import { Component } from 'vue-property-decorator';

@Component({
  name: 'CmgSubscribeEmailMarketingModal'
})
export default class CmgSubscribeEmailMarketingModal extends Vue {
  enableEmailMarketingValue = false;
  errorMessage: string | null = null;
  isBusy = false;

  get visible(): boolean {
    return this.$appStore.state.ui.modals.subscribeEmailMarketing.visible;
  }

  get isMobile(): boolean {
    return this.$services.ui.isMobile();
  }

  get medallionImageSource(): string {
    return this.$appStore.state.cms.images.logos.medallionRewardShout.default;
  }

  setEnableEmailMarketing(value: boolean): void {
    this.enableEmailMarketingValue = value;
  }

  async updateEmailMarketingPreference(): Promise<void> {
    this.errorMessage = null;
    let isSuccessful = true

    if (this.enableEmailMarketingValue) {
      try {
        this.isBusy = true;
        await this.$services.customer.subscribeToMarketingChannel(MarketingChannel.Email, MarketingContext.Marketing);
      }
      catch (err) {
        isSuccessful = false
        this.errorMessage = err instanceof CustomerError
          ? err.message
          : 'Something went wrong. Please try again.'
      }
      finally {
        this.isBusy = false;
      }
    }

    if (isSuccessful) {
      this.closeModal()
    }
  }

  closeModal() {
    this.$services.ui.setModalVisibility('subscribeEmailMarketing', false);
  }
}
